import * as React from 'react';
import classNames from 'classnames';
import { brightNavy } from '../../cssConstants';
import Button from '../../../commonComponents/Button';

const PrimaryButton = ({
	type,
	className,
	id,
	img,
	onClick,
	disabled,
	text,
	backgroundColor,
	children,
	tabIndex
}: Props) => (
	<Button
		onClick={onClick}
		textColour="white"
		backgroundColor={backgroundColor}
		className={classNames('formStyledButton', 'primaryButton', className)}
		id={id}
		disabled={disabled}
		type={type}
		text={text}
		tabIndex={tabIndex}
		img={img}
	>
		<>{children}</>
	</Button>
);

interface Props {
	text?: string;
	onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
	type?: 'button' | 'submit' | 'reset';
	disabled?: boolean;
	className?: string;
	id?: string;
	img?: JSX.Element;
	backgroundColor?: string;
	children?: string | JSX.Element | JSX.Element[];
	tabIndex?: number;
}

PrimaryButton.defaultProps = {
	text: null,
	onClick: null,
	type: 'button',
	disabled: false,
	className: null,
	id: 'primaryButton',
	img: null,
	backgroundColor: brightNavy,
	children: null,
	tabIndex: undefined
};

export default PrimaryButton;
